import { defaultAxios, IParams } from './base';

export interface IPutMonthlyRequestStatus extends IParams {
  // condition 없음
}

export const putMonthlyRequestStatus = (params: any) => {
  return defaultAxios().put(`/loan/MonthlyRequest/status`, params);
};
